import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { $Enums, NewContract } from '@vae/server/dist/client'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface NewContractTypeStepProps {
	contract: Partial<NewContract>
	setContract: (key: keyof NewContract, value: any) => void
}

const NewContractTypeStep: React.FC<NewContractTypeStepProps> = ({ contract, setContract }) => {
	const { t } = useTranslation('modals_createContract')

	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
			<RadioGroup
				value={contract.newContractType ?? $Enums.NewContractType.moveIn}
				onChange={e => setContract('newContractType', e.target.value as $Enums.NewContractType)}
			>
				<FormControlLabel
					className='text-text-dark dark:text-white'
					value={$Enums.NewContractType.moveIn}
					control={<Radio color='primary' />}
					label={t('newContractTypeStep.moveIn')}
				/>
				<FormControlLabel
					className='text-text-dark dark:text-white'
					value={$Enums.NewContractType.changeCompany}
					control={<Radio color='primary' />}
					label={t('newContractTypeStep.changeCompany')}
				/>
				<FormControlLabel
					className='text-text-dark dark:text-white'
					value={$Enums.NewContractType.newContract}
					control={<Radio color='primary' />}
					label={t('newContractTypeStep.newContract')}
				/>
				<FormControlLabel
					className='text-text-dark dark:text-white'
					value={$Enums.NewContractType.swapContract}
					control={<Radio color='primary' />}
					label={t('newContractTypeStep.swapContract')}
				/>
			</RadioGroup>
		</div>
	)
}

export default NewContractTypeStep
